module.exports = __webpack_public_path__ + "img/zan.c28032c8.png";